import { useEffect, useRef } from 'react';

/**
 * Polling simples (mesmo espírito do setInterval de 30s do sino de notificações em
 * AppLayout.tsx) — pula o tick quando a aba está em segundo plano (document.hidden) e
 * dispara um refresh extra assim que a aba volta a ficar visível, pra não esperar até
 * 1 ciclo inteiro pra atualizar quem só voltou o foco pra tela.
 */
export function usePollingRefresh(callback: () => void, intervalMs: number, enabled: boolean): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) return;

    const tick = () => {
      if (document.hidden) return;
      callbackRef.current();
    };

    const interval = setInterval(tick, intervalMs);

    const handleVisibilityChange = () => {
      if (!document.hidden) callbackRef.current();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [intervalMs, enabled]);
}
